import React from 'react';

const Spacer = ({ 
    height = '20px', 
    width = '100%', 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className 
}) => {
    return (
        <div 
            className={className} 
            style={{ 
                height, 
                width, 
                ...style 
            }} 
        />
    );
};

export default Spacer;

